import React from "react";
import { useUserPermissions } from "../../../contexts/UserPermissionsContext";
import "./RequireUpload.css";

// Guards upload-only surfaces. Hiding the sidebar entry alone is cosmetic —
// /route/setup stays reachable by URL, bookmark, and the in-app link inside
// UploadForm's batch-upload notice.
//
// While permissions load we render the children: a "no permission" flash on
// every page load is worse than a brief form flash for the rare blocked user.
export default function RequireUpload({ children }) {
  const { canUpload, loading } = useUserPermissions();
  if (loading || canUpload) return children;
  return (
    <div className="require-upload-denied">
      <h2>Keine Upload-Berechtigung</h2>
      <p>
        Ihr Konto ist zum Lesen und Suchen berechtigt, aber nicht zum Hochladen
        von Dokumenten. Bitte wenden Sie sich an Ihren Administrator.
      </p>
    </div>
  );
}
